import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledThemeActivityIcons = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 5px;
  margin-top: 5px;

  .theme-activity-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .count {
      position: absolute;
      top: -5px;
      right: -5px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 15px;
      width: 15px;
      font-size: 11px;
      line-height: 1px;
      background-color: white;
      border: 1px solid ${Colors.text};
    }
  }
`;
